var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "trial-button-container": true,
        container: true,
        mobile: _vm.isMobile(_vm.$mq),
        "has-money-back-copy": _vm.showMoneyBackTextCopy
      }
    },
    [
      _c("div", [
        _c("div", [
          _vm.shouldShowDiscount
            ? _c(
                "p",
                { class: { discount: true, "green-text": true } },
                [
                  _c("LightningSvg", { staticClass: "lightning-icon" }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.discountHtml) }
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.annualPlan
          ? _c("p", [
              _vm.strikeThroughPrice
                ? _c("s", [_vm._v(_vm._s(_vm.strikeThroughPrice))])
                : _vm._e(),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.experimentAwareTrialPlanPriceMessage) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.user.is_during_trial
          ? _c(
              "button",
              {
                staticClass: "btn trial-active",
                attrs: {
                  "data-testid": "trial_is_already_active_button",
                  disabled: ""
                }
              },
              [_vm._v("\n      You're on your trial\n    ")]
            )
          : _c(
              "button",
              {
                staticClass: "btn btn-green",
                class: {
                  "btn-experiment": _vm.experimentContent !== undefined
                },
                attrs: {
                  "data-testid": "start_your_trial_button",
                  "data-price-vendor": _vm.annualPlan.price_vendor
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.handleAnnualClick($event)
                  }
                }
              },
              [
                _vm.matureUsers
                  ? [_vm._v(" Subscribe now ")]
                  : _vm.experimentContent
                  ? [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.experimentContent.buttonText) +
                          "\n      "
                      )
                    ]
                  : _vm.annualPlanIsTrialPlan
                  ? [
                      _vm._v(
                        "\n        Start your " +
                          _vm._s(_vm.trialLength) +
                          "-day free trial\n      "
                      )
                    ]
                  : _vm.annualPlan
                  ? [_vm._v(" Subscribe now ")]
                  : [
                      _vm._v(
                        " Start your " +
                          _vm._s(_vm.trialLength) +
                          "-day free trial "
                      )
                    ]
              ],
              2
            ),
        _vm._v(" "),
        _vm.showMoneyBackTextCopy
          ? _c("p", { staticClass: "money-back-copy" }, [
              _vm._v(
                "\n      Backed by our " +
                  _vm._s(_vm.trialLength) +
                  "-day money back guarantee\n    "
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }